import PublicHeader from "@/components/public/PublicHeader";
import Hero from "@/components/public/Hero";
import PlanVisit from "@/components/public/PlanVisit";
import LatestCollection from "@/components/public/LatestCollection";
import CollectionCategories from "@/components/public/CollectionCategories";
import InstagramFeed from "@/components/public/InstagramFeed";
import ContactSection from "@/components/public/ContactSection";
import Footer from "@/components/public/Footer";
import FloatingWhatsApp from "@/components/public/FloatingWhatsApp";
import { useEffect } from "react";

export default function PublicHome() {
  useEffect(() => {
    document.title = "Sky Basket Stationery & Gifts";
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="public-home">
      <PublicHeader />
      <main>
        <Hero />
        <PlanVisit />
        <LatestCollection />
        <CollectionCategories />
        <InstagramFeed />
        <ContactSection />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
